import { createSelector } from './selectorWrapper'
import { simpleSelectors } from './basicState'

export const refundingDetails = createSelector(
  [simpleSelectors.refunding, simpleSelectors.refund],
  (refunding, titleIdToRefund) => {
    if (
      !refunding ||
      !titleIdToRefund[refunding.titleId] ||
      titleIdToRefund[refunding.titleId]!.refundableOrders.length === 0
    ) {
      return null
    }

    const { titleId } = refunding
    const { asin: titleIdOrder, csrfToken } = titleIdToRefund[
      titleId
    ]!.refundableOrders[0]
    const isAsin = /^[a-zA-Z0-9]{10}$/.test(titleIdOrder)
    return {
      asin: isAsin ? titleIdOrder: undefined,
      gti: !isAsin ? titleIdOrder: undefined,
      csrfToken
    }
  }
)
